
import { LABEL_VALUE, LOGIN_VALUE } from "./storeTypes";
export const LoginValue = (value) => ({
  type: LOGIN_VALUE,
  payload: value,
});
export const LabelValue = (value) => ({
  type: LABEL_VALUE,
  payload: value,
});

export const dataPatient = (data) => ({
  type: 'PATIENT_DATA',
  payload: data
  });